"use client";

import { useEffect, useRef, useState } from "react";
import { usePathname } from "next/navigation";
import DeviceIdLogic from "components/layouts/Header/DeviceIdLogic";
import UsersCurrencyLogic from "components/layouts/Header/UsersCurrencyLogic";
import { SHOW_SUPPORT_BAR } from "constant";
import { useIsAgent } from "hooks/useIsAgent";
import AppHeaderInner from "./AppHeaderInner";
import HeaderAlert from "./HeaderAlert";
import SupportBar from "./SupportBar";
const AppHeaderNewHome = () => {
  const pathname = usePathname();
  const headerRef = useRef<HTMLDivElement>(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  // Support bar is for travel agents only, gated by a global toggle.
  const isAgent = useIsAgent();
  const showSupportBar = SHOW_SUPPORT_BAR && isAgent;
  const isPaymentPage = pathname?.startsWith("/payment");
  const isVacationRentalPage = pathname?.startsWith("/vacation-rentals");
  const hideHeaderOnDesktop = isPaymentPage || isVacationRentalPage;
  const isHomePage = ["/", "/login", "/ta-login", "/about-us"].includes(pathname || "");
  const isSecondaryThemePage = ["/signup", "/frequently-asked-questions", "/privacy", "/terms", "/webinars", "/help-support-center"].includes(pathname || "");
  const isHeaderFixed = !isHomePage;

  // The fixed header is pulled out of the document flow, so a spacer keeps page
  // content from hiding behind it. Measure the live height (header + support
  // bar, which can wrap on small screens) so the offset stays correct.
  useEffect(() => {
    const el = headerRef.current;
    if (!el) return;
    const update = () => setHeaderHeight(el.offsetHeight);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => observer.disconnect();
  }, [pathname]);
  const headerThemeClassName = isHomePage ? "bg-transparent text-white" : isSecondaryThemePage ? "bg-secondary500 text-white" : "bg-primary-500 text-white";
  return <>
      <HeaderAlert data-sentry-element="HeaderAlert" data-sentry-source-file="AppHeader.tsx" />
      <div ref={headerRef} className={`${isHeaderFixed ? "fixed left-0 right-0 top-0 " : "relative "} ${hideHeaderOnDesktop ? "hidden md:block" : ""} z-[900] w-full ${headerThemeClassName}`}>
        {showSupportBar && <SupportBar />}
        <AppHeaderInner data-sentry-element="AppHeaderInner" data-sentry-source-file="AppHeader.tsx" />
      </div>
      {isHeaderFixed && <div aria-hidden style={headerHeight ? {
      minHeight: headerHeight
    } : undefined} className={`${hideHeaderOnDesktop ? "hidden md:block" : ""} min-h-[100px] md:min-h-[120px]`}>
          {/* this is added to add space on top of content such that contant doesn't hide behind header */}
        </div>}
      <DeviceIdLogic data-sentry-element="DeviceIdLogic" data-sentry-source-file="AppHeader.tsx" />
      <UsersCurrencyLogic data-sentry-element="UsersCurrencyLogic" data-sentry-source-file="AppHeader.tsx" />
    </>;
};
export default AppHeaderNewHome;